module.exports = __webpack_public_path__ + "2700acc9ffd33b5bbb3866bd8b34ab32.svg";